import { render, staticRenderFns } from "./ContentfulSyncDetailView.vue?vue&type=template&id=7042bfc7"
import script from "./ContentfulSyncDetailView.vue?vue&type=script&lang=js"
export * from "./ContentfulSyncDetailView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports